import { Link } from "react-router-dom";
import { typeLabel, type MediaType } from "@/mocks/media";

export default function Footer({ compact = false }: { compact?: boolean }) {
  const columns: { title: string; links: { label: string; to: string }[] }[] = [
    {
      title: "频道",
      links: [
        { label: "电影", to: "/category/movie" },
        { label: "电视剧", to: "/category/tv" },
        { label: "综艺", to: "/category/variety" },
      ],
    },
    {
      title: "快速入口",
      links: [
        { label: "最新更新", to: "/" },
        { label: "影视搜索", to: "/search" },
        { label: "热门推荐", to: "/category/movie" },
      ],
    },
    {
      title: "关于",
      links: [
        { label: "网站介绍", to: "/about" },
        { label: "联系我们", to: "/about" },
        { label: "反馈建议", to: "/about" },
      ],
    },
  ];

  const types: MediaType[] = ["movie", "tv", "variety"];

  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-0">
      {!compact && (
        <div className="border-b border-primary-800">
          <div className="w-full px-4 md:px-6 xl:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-center justify-between gap-5">
            <div>
              <h4 className="font-heading text-lg md:text-xl font-semibold text-background-50">
                想看的剧，总能在这里找到
              </h4>
              <p className="text-sm text-background-300 mt-1.5">
                本站为影视资源展示与浏览平台，所有作品信息均为示例演示内容。
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {types.map((t) => (
                <Link
                  key={t}
                  to={`/category/${t}`}
                  className="px-4 h-9 inline-flex items-center rounded-full text-sm bg-primary-900 border border-primary-800 text-background-100 hover:bg-secondary-500 hover:text-foreground-950 hover:border-secondary-500 transition-colors whitespace-nowrap"
                >
                  {typeLabel[t]}频道
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="w-full px-4 md:px-6 xl:px-10 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-play-fill"></i>
              </span>
              <span className="font-heading font-bold text-[18px] text-background-50">
                91<span className="text-accent-500">视频</span>网站
              </span>
            </Link>
            <p className="text-sm leading-6 text-background-300 mt-3 max-w-xs">
              汇集最新电影、电视剧和综艺节目的资源浏览平台，帮助你更快找到想看的内容。
            </p>
            <div className="flex items-center gap-2 mt-4">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-8 h-8 rounded-md bg-primary-900 flex items-center justify-center text-background-300 hover:text-secondary-400 transition-colors"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <h5 className="font-heading text-sm font-semibold text-background-50 mb-3">{col.title}</h5>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-secondary-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-9 pt-5 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 91视频网站 · 本站为示例演示站点，所有影视作品、演职人员与评分均为虚构内容
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span className="whitespace-nowrap">内容仅作展示</span>
            <span className="whitespace-nowrap">不提供真实播放</span>
          </div>
        </div>
      </div>
    </footer>
  );
}